import { Node_Type } from "./../ricos-types";
import { INSERT_PLUGIN_BUTTONS, TOOLBARS } from "./../editor-common";
import { gifModals } from "./constants";
import { INSERT_GIF_BUTTON } from "./data-hooks";
import { InsertPluginIcon } from "./icons";
import { GiphyInsertModal } from "./modals/InsertModal";
const toolbarsToAddIn = [
  TOOLBARS.MOBILE,
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE
];
const getAddButtons = (config, services) => {
  const {
    modals,
    context: { isMobile }
  } = services;
  return [
    {
      id: Node_Type.GIF,
      label: INSERT_PLUGIN_BUTTONS.GIF,
      dataHook: INSERT_GIF_BUTTON,
      icon: InsertPluginIcon,
      tooltip: "GiphyPlugin_InsertButton_Tooltip",
      toolbars: toolbarsToAddIn,
      command: ({ referenceElement }) => {
        modals?.togglePluginPanel({
          id: gifModals.insert,
          Component: GiphyInsertModal,
          componentProps: {
            modalId: gifModals.insert,
            getGiphyUrl: config?.getGiphyUrl
          },
          isMobile,
          positioning: {
            referenceElement,
            placement: "bottom"
          }
        });
        return true;
      },
      menuConfig: {
        tags: "Gif_plugin_search_tags"
      }
    }
  ];
};
export {
  getAddButtons,
  toolbarsToAddIn
};
//# sourceMappingURL=getAddButtons.js.map
